import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AppWrapper from './App';

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>,
  document.getElementById('root')
);
